import script from "./DashboardDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardDetailsModal.vue?vue&type=style&index=0&id=685501e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685501e0"]])

export default __exports__